export function clearRedux () {
  return {
    type: '@main/CLEAR_REDUX'
  }
}
